export const ARCHIVED_FILTER_TYPE = 'archive_status'
export const ARCHIVED_FILTER_ID = 'archived'

export const isArchivedFilter = (filter) =>
  filter.type === ARCHIVED_FILTER_TYPE && filter.id === ARCHIVED_FILTER_ID

export const hasArchivedFilter = (filters = []) =>
  filters.some(isArchivedFilter)

export const createArchivedFilter = (label) => ({
  type: ARCHIVED_FILTER_TYPE,
  id: ARCHIVED_FILTER_ID,
  label
})
